import { z } from "zod";
import { ZDateish, } from "./foundationSchema";
/* -------------------------------------------------------------------------- */
/*  Release reads                                                             */
/* -------------------------------------------------------------------------- */
export const ZReleaseRead = z.object({
    _id: z.any().optional(),
    // Referanse til users._id
    userId: z.any(),
    // Referanse til releaseNotes._id (siste release brukeren har sett)
    lastSeenReleaseId: z.any().optional(),
    // Når brukeren sist oppdaterte "sett"-status
    updatedAt: ZDateish,
});
